import { render } from "./ModuleEmploymentTypes.vue?vue&type=template&id=072880e2&scoped=true"
import script from "./ModuleEmploymentTypes.vue?vue&type=script&lang=js"
export * from "./ModuleEmploymentTypes.vue?vue&type=script&lang=js"

import "./ModuleEmploymentTypes.vue?vue&type=style&index=0&id=072880e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072880e2"]])

export default __exports__